"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Env_1 = require("src/Env");
var RouterLink_1 = require("./RouterLink");
exports.RouterLink = RouterLink_1.RouterLink;
exports.fallbackUrl = function () { return Env_1.NATIVE_APPLICATION ? '/' : Env_1.BOOKSHELF_URL + "/library"; };
exports.logoutUrl = function () { return Env_1.NATIVE_APPLICATION ? '/logOut' : Env_1.BOOKSHELF_URL + "/logOut"; };
